export default [

  {
    path: '*',
    meta: {
      public: true,
    },
    redirect: {
      path: '/404'
    }
  },
  {
    path: '/admin',
    meta: {
      public: true,
    },
    redirect: {
      path: 'https://old.phanmemdathangoee.com/admin'
    }
  },
  {
    path: '/404',
    meta: {
      public: true,
    },
    name: 'NotFound',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/NotFound.vue`
    )
  },
  {
    path: '/403',
    meta: {
      public: true,
    },
    name: 'AccessDenied',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Deny.vue`
    )
  },
  {
    path: '/500',
    meta: {
      public: true,
    },
    name: 'ServerError',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Error.vue`
    )
  },
  {
    path: '/',
    meta: {title: 'Tổng quan', roleId: 1},
    name: 'Root',
    redirect: {
      name: 'Dashboard'
    }
  },
  {
    path: '/login',
    meta: {
      public: true,
    },
    name: 'Login',
    component: () => import(
      /* webpackChunkName: "routes" */
      `@/views/Login.vue`
    )
  },
  {
    path: '/tai-khoan',
    meta: { title: 'Cập nhật tài khoản', breadcrumb: true, requiresAuth: true, saveButton: true, roleId: 1},
    name: 'Profile',
    component: () => import(
      `@/views/Profile.vue`
    )
  },
  {
    path: '/dashboard',
    meta: { title: 'Bảng điều khiển', breadcrumb: true, requiresAuth: true, roleId: 1},
    name: 'Dashboard',
    component: () => import(
      `@/views/Dashboard.vue`
    )
  },
  {
    path: '/quan-ly-san-pham/san-pham-ban',
    meta: { title: 'Sản phẩm bán', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 1 },
    name: 'Products',
    component: () => import(
      `@/views/Products/list.vue`
    )
  },
  {
    path: '/quan-ly-san-pham/chi-tiet-san-pham/:Pid',
    meta: { title: 'Chi tiết sản phẩm', breadcrumb: true, requiresAuth: true, saveButton: true, createButton: true, refreshButton: true, createButtonText: "Sao chép", createButtonIcon: "content_copy", roleId: 1 },
    name: 'ProductDetail',
    component: () => import(
      `@/views/Products/detail.vue`
    )
  },
  {
    path: '/quan-ly-san-pham/san-pham-xuat',
    meta: { title: 'Sản phẩm xuất', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 1 },
    name: 'ExportProducts',
    component: () => import(
      `@/views/Products/list.vue`
    )
  },
  {
    path: '/quan-ly-san-pham/san-pham-xuat/:Pid',
    meta: { title: 'Chi tiết sản phẩm', breadcrumb: true, requiresAuth: true, saveButton: true, createButton: true, createButtonText: "Sao chép", createButtonIcon: "content_copy", roleId: 1 },
    name: 'ExportProductDetail',
    component: () => import(
      `@/views/Products/detail.vue`
    )
  },
  {
    path: '/quan-ly-san-pham/san-pham-sale',
    meta: { title: 'Sản phẩm sale', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 1 },
    name: 'SaleProducts',
    component: () => import(
      `@/views/Products/list.vue`
    )
  },
  {
    path: '/quan-ly-san-pham/san-pham-sale/:Pid',
    meta: { title: 'Chi tiết sản phẩm', breadcrumb: true, requiresAuth: true, saveButton: true, createButton: true, createButtonText: "Sao chép", createButtonIcon: "content_copy", roleId: 1 },
    name: 'SaleProductDetail',
    component: () => import(
      `@/views/Products/detail.vue`
    )
  },
  {
    path: '/quan-ly-san-pham/danh-muc',
    meta: { title: 'Danh mục', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 1 },
    name: 'Categories',
    component: () => import(
      `@/views/Categories/list.vue`
    )
  },
  {
    path: '/quan-ly-don-hang/don-ban',
    meta: { title: 'Đơn bán', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, saveButton:true, saveButtonText: 'Cập nhật', roleId: 1 },
    name: 'Orders',
    component: () => import(
      `@/views/Orders/list.vue`
    )
  },
  {
    path: '/quan-ly-don-hang/don-sale',
    meta: { title: 'Đơn sale', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, saveButton:true, saveButtonText: 'Cập nhật', roleId: 1 },
    name: 'SaleOrders',
    component: () => import(
      `@/views/Orders/list.vue`
    )
  },
  {
    path: '/quan-ly-don-hang/don-xuat',
    meta: { title: 'Đơn xuất', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 1 },
    name: 'ExportOrders',
    component: () => import(
      `@/views/Receipts/list.vue`
    )
  },
  {
    path: '/quan-ly-don-hang/don-xuat/:Pid',
    meta: { title: 'Chi tiết đơn xuất', breadcrumb: true, requiresAuth: true, saveButton: true, otherButton: true, otherButtonText: 'In HĐ', otherButtonIcon: 'print', roleId: 1 },
    name: 'ExportOrderDetail',
    component: () => import(
      `@/views/Receipts/detail.vue`
    )
  },
  {
    path: '/quan-ly-don-hang/don-nhap',
    meta: { title: 'Trả hàng', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 1 },
    name: 'Returns',
    component: () => import(
      `@/views/Returns/list.vue`
    )
  },
  {
    path: '/quan-ly-don-hang/don-nhap/:Pid',
    meta: { title: 'Chi tiết trả hàng', breadcrumb: true, requiresAuth: true, saveButton: true, otherButton: true, otherButtonText: 'In HĐ', otherButtonIcon: 'print', roleId: 1 },
    name: 'ReturnDetail',
    component: () => import(
      `@/views/Returns/detail.vue`
    )
  },
  {
    path: '/quan-ly-tai-khoan/nhan-vien',
    meta: { title: 'Nhân viên', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 1 },
    name: 'Users',
    component: () => import(
      `@/views/Users/list.vue`
    )
  },
  {
    path: '/quan-ly-tai-khoan/khach-hang',
    meta: { title: 'Khách hàng', breadcrumb: true, requiresAuth: true, createButton: true, refreshButton: true, roleId: 1 },
    name: 'Customers',
    component: () => import(
      `@/views/Customers/list.vue`
    )
  },
  {
    path: '/bao-cao/bao-cao-ban-hang/',
    meta: { title: 'Báo cáo bán hàng', breadcrumb: true, requiresAuth: true, roleId: 1 },
    name: 'Reports',
    component: () => import(
      `@/views/Reports/bao-cao.vue`
    )
  },
  {
    path: '/bao-cao/bao-cao-xuat-hang/',
    meta: { title: 'Báo cáo xuất hàng', breadcrumb: true, requiresAuth: true, roleId: 1 },
    name: 'ReceiptReports',
    component: () => import(
      `@/views/Reports/bao-cao-xuat.vue`
    )
  },
  {
    path: '/bao-cao/bao-cao-tra-hang/',
    meta: { title: 'Báo cáo trả hàng', breadcrumb: true, requiresAuth: true, roleId: 1 },
    name: 'ReturnReports',
    component: () => import(
      `@/views/Reports/bao-cao-nhap.vue`
    )
  },
  {
    path: '/thanh-toan/',
    meta: { title: 'Thanh toán', breadcrumb: true, createButton: true, rrequiresAuth: true, roleId: 1 },
    name: 'Recharges',
    component: () => import(
      `@/views/Recharges/list.vue`
    )
  },
  {
    path: '/nhat-ky-he-thong/',
    meta: { title: 'Nhật ký hệ thống', breadcrumb: true, rrequiresAuth: true, refreshButton: true, roleId: 1 },
    name: 'SystemLogs',
    component: () => import(
      `@/views/SystemLogs/list.vue`
    )
  },
];
